enum RequesterFieldType {
  CHECKBOX_FIELD = 'CHECKBOX_FIELD',
  IMAGE_FIELD = 'IMAGE_FIELD',
  TEXT_FIELD = 'TEXT_FIELD',
}

export default RequesterFieldType;
